import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { routePaths } from 'components/Routes/data';
import { showToastViaEvent } from 'utils/ToastEvents';
import { AIWorkflowConfig } from '../../types';
import { WorkflowBuilder } from '../WorkflowBuilder';

const CreateWorkflowView = () => {
  const history = useHistory();

  const handleSave = useCallback(
    (_workflow: AIWorkflowConfig) => {
      showToastViaEvent({
        text: 'Workflow saved successfully',
        type: 'success',
        timeout: 3000,
      });
      history.push(routePaths.aiWorkflow.myFlows);
    },
    [history],
  );

  const handleCancel = useCallback(() => {
    history.push(routePaths.aiWorkflow.myFlows);
  }, [history]);

  return <WorkflowBuilder onSave={handleSave} onCancel={handleCancel} />;
};

export { CreateWorkflowView };
